/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { View } from 'react-native'
import Label from '../../Label';

export const DetailSinistreComponent = (props: any) => {
    const { title, value } = props;
    return (
        <View>
            <Label type="titleGreen14" title={`${title}: `} />
            <Label
                type="paragraph14"
                title={value}
            />
        </View>
    )
};
